import * as React from 'react';
import { connect } from 'react-redux';
import * as $ from 'jquery';

import { CategoryDocsList } from './category-articles-list.presentation';
import { Alert } from '../common/alert/alert.presentation';

import { getCategoryArticlesIfNeeded, changePage } from '../../actions/category-articles.action';
import { Store } from '../../store/';

interface Props {
    error: string;
    page: number;
    total: number;
    activeCategory: string;
    items: Array<any>;
    loading: boolean;
    dispatch: any;
}

class CategoryArticlesComponent extends React.Component<Props> {
    state = {
        view: 'items'
    };

    constructor(props, context) {
        super(props, context);

        this.setPage = this.setPage.bind(this);
        this.changeView = this.changeView.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(getCategoryArticlesIfNeeded(this.props.activeCategory));
    }

    setPage(page: number) {
        $('html, body').animate({scrollTop: 0}, 'slow');

        this.props.dispatch(changePage(page));
    }

    changeView(e) {
        e.preventDefault();

        if (this.state.view === 'items') {
            this.setState({ view: 'cards' });
        }
        else {
            this.setState({ view: 'items' });
        }
    }

    render() {
        if (this.props.error) {
            return (<div className='container'>
                <Alert message={this.props.error} type='negative' />
            </div>);
        }
        else {
            return <CategoryDocsList
                    loading={this.props.loading}
                    items={this.props.items}
                    page={this.props.page}
                    total={this.props.total}
                    setPage={this.setPage}
                    limit={18}
                    view={this.state.view}
                    changeView={this.changeView}
                />;
        }
    }
}

const mapStateToProps = (state: Store) => {
    const category = state.categoryArticles.activeCategory;
    const start = state.categoryArticles.page * 18 - 18;
    const end = start + 18;
    let total = 0;
    let items = [];
    if (typeof state.categoryArticles.categories[category] !== 'undefined') {
        total = state.categoryArticles.categories[category].total;
        items = state.categoryArticles.categories[category].items.slice(start, end);
    }

    return {
        error: state.categoryArticles.error,
        page: state.categoryArticles.page,
        total,
        items,
        loading: state.categoryArticles.isFetching || !state.categoryArticles.loaded,
        activeCategory: category
    }
};

const CategoryArticles = connect(mapStateToProps)(CategoryArticlesComponent);

export default CategoryArticles;



// WEBPACK FOOTER //
// ./src/components/category-articles/category-articles.component.tsx